import { render, staticRenderFns } from "./FacturaDelete.vue?vue&type=template&id=a051b42e"
import script from "./FacturaDelete.vue?vue&type=script&lang=js"
export * from "./FacturaDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports